var tooltip = function () {
    var id = 'tt';
    var top = 3;
    var left = 3;
    var maxw = 300;
    var speed = 10;
    var timer = 20;
    var endalpha = 95;
    var alpha = 0;
    var tt, t, c, b, h, otg, olg, width_g;
    var ie = document.all ? true : false;
    return {
        show: function (v, w, ot, ol, width) {
            otg = ot;
            olg = ol;
            width_g = width;

            if (tt == null) {
                tt = document.createElement('div');
                tt.setAttribute('id', id);

                t = document.createElement('div');
                t.setAttribute('id', id + 'top');
                c = document.createElement('div');
                c.setAttribute('id', id + 'cont');
                b = document.createElement('div');
                b.setAttribute('id', id + 'bot');

                tt.appendChild(t);
                tt.appendChild(c);
                tt.appendChild(b);

                document.body.appendChild(tt);
                tt.style.opacity = 0;
                tt.style.filter = 'alpha(opacity=0)';

                //document.onmousemove = this.pos;                
            }

            tt.style.display = 'block';
            c.innerHTML = v;
            tt.style.width = w ? w + 'px' : 'auto';
            if (!w && ie) {
                t.style.display = 'none';
                b.style.display = 'none';
                tt.style.width = tt.offsetWidth;
                t.style.display = 'block';
                b.style.display = 'block';
            }
            if (tt.offsetWidth > maxw) { tt.style.width = maxw + 'px' }
            h = parseInt(tt.offsetHeight) + top;
            clearInterval(tt.timer);
            tt.timer = setInterval(function () { tooltip.fade(1) }, timer);

            tt.style.top = (otg - h + 3) + 'px';
            tt.style.left = (olg + width_g - 5) + 'px';
        },
        // event handler
        pos: function (e) {
            var u = ie ? event.clientY + document.documentElement.scrollTop : e.pageY;
            var l = ie ? event.clientX + document.documentElement.scrollLeft : e.pageX;

            if (otg && olg && width_g) {
                tt.style.top = (otg - h + 3) + 'px';
                tt.style.left = (olg + width_g - 5) + 'px';
            }
            else {
                tt.style.top = (u - h) + 'px';
                tt.style.left = (l + left) + 'px';
            }
        },
        fade: function (d) {
            var a = alpha;
            if ((a != endalpha && d == 1) || (a != 0 && d == -1)) {
                var i = speed;
                if (endalpha - a < speed && d == 1) {
                    i = endalpha - a;
                } else if (alpha < speed && d == -1) {
                    i = a;
                }
                alpha = a + (i * d);
                tt.style.opacity = alpha * .01;
                tt.style.filter = 'alpha(opacity=' + alpha + ')';
            } else {
                clearInterval(tt.timer);
                if (d == -1) { tt.style.display = 'none' }
            }
        },
        hide: function () {
            if (tt && tt.timer) {
                clearInterval(tt.timer);
                tt.timer = setInterval(function () { tooltip.fade(-1) }, timer);
            }
        },
        position: function () {
            tt.style.top = (otg - h + 3) + 'px';
            tt.style.left = (olg + width_g - 5) + 'px';
        }
    };
}();

function showSimpleToolTip(text, h, w, width) {
    tooltip.show(text, 150, h, w, width);
}

function showToolTip(id, canShow) {
    this.showToolTip(id, canShow, '', '', '');
}

function showToolTip(id, canShow, h, w, width) {
    if (canShow.toLowerCase() == 'true') {

        var text = '';

        // unit type
        if (id == 1)
            text =          'Listen carefully to the size and amenity requirements.';
        // name
        else if (id == 2)
            text =
                            '<ul style="padding-left:2em">' +
                                '<li>Personalize the call.</li>' +
                                '<li>Ask for the customer\'s full name.</li>' +
                                '<li>Use the customer\'s name often.</li>' +
                                '<li>Smile.</li>' +
                            '</ul>';
        // lead source
        else if (id == 3)
            text =
                            '<ul style="padding-left:2em">' +
                                '<li>"Drive by" is NOT a source. Ask more questions such as: questions to arrive at the correct source.</li>' +
                            '</ul>';
        // desired move-in date                                  
        else if (id == 4)
            text =          'Ask if they are flexible with their move in date.';
        // occupants
        else if (id == 5)
            text =
                            '<ul style="padding-left:2em">' +
                                '<li>Ask about occupants</li>' +
                                '<li>Ask about pets</li>' +
                            '</ul>';
        // price range
        else if (id == 6)
            text =          'Ask about preferred price range';
        // features
        else if (id == 7)
            text =
                            'Make additional notes' +
                            '<ul style="padding-left:2em">' +
                                '<li>Comments.</li>' +
                                '<li>Questions.</li>' +
                                '<li>Likes and dislikes.</li>' +
                            '</ul>';
        // appointment
        else if (id == 8)
            text =          'Offer two appointment options';
        // email
        else if (id == 9)
            text =          'Many customers prefer to be contacted via e-mail.';
        // lease term
        else if (id == 10)
            text = 'Ask if the customer is flexible with their move in date.';
        
        tooltip.show(text, 200, h, w, width);
    }
}

function showTipBar(id, canShow) {
    if (canShow.toLowerCase() == 'true') {
        var text = '';

        // default
        if (id == 1) {
            text = '<div style="padding: 2px; height:100%;">' +
                        '<div style="display:inline-block; width:200px;">' +
                            '<div>Remember:</div>' +
                            '<ul>' +
                                '<li>Smile</li>' +
                                '<li>Create Rapport</li>' +
                                '<li>Be Conversational</li>' +
                                '<li>Show Interest</li>' +
                            '</ul>' +
                        '</div>' +
                        '<div style="display:inline-block; vertical-align:top; border-left:1px solid black; height:100%; width:350px; font-style:italic; padding-left:2px">' +
                            '<font style="font-weight:bold;">Greeting:</font>' +
                            '<ul>' +
                                '<li>' +
                                    'Thank you for choosing (community name), a Greystar Community, this is (your name), and it would be my pleasure to assist you.' +
                                '</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>';

        }
        // unit type
        else if (id == 2) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>Take a moment to describe the perfect apartment home.</li>' +
                            '<li>"How many bedrooms and bathrooms?"</li>' +
                            '<li>"Do you have any specific needs or preferences?"</li>' +
                            '<li>"What is most important to you in your new home?"</li>' +
                        '</ul>' +
                    '</div>';
        }
        // name
        else if (id == 3) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>"My name is_____ and you are?"</li>' +
                            '<li>"Hi _______. How are you today? Thank you for taking the time to call our community ______________."</li>' +
                            '<li>"I want to find the apartment that is perfect for you, do you mind if I ask you a few questions?"</li>' +
                        '</ul>' +
                    '</div>';
        }
        // lead source
        else if (id == 4) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>"How did you get our phone number?"</li>' +
                            '<li>"What was it that prompted you to contact/visit us today?"</li>' +
                            '<li>"How did you discover our community?"</li>' +
                        '</ul>' +
                    '</div>';
        }
        // desired move-in date
        else if (id == 5) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>"When are you planning to move?"</li>' +
                            '<li>"Do you mind if I ask why you are considering a move right now?"</li>' +
                            '<li>"Are you living in an apartment home currently?" If so, assess their experience.</li>' +
                            '<li style="font-weight:bold;">Sell Greystar and our commitment to customer service.</li>' +
                        '</ul>' +
                    '</div>';
        }
        // occupants
        else if (id == 6) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>1 Bedroom - 2 people (3 people if Familial Status)</li>' +
                            '<li>2 Bedroom - 4 people (5 people if Familial Status)</li>' +
                            '<li>3 Bedroom - 6 people (7 people if Familial Status)</li>' +
                            '<li>4 Bedroom - 8 people (9 people if Familial Status)</li>' +
                        '</ul>' +
                    '</div>';
        }
        // price range
        else if (id == 7) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>"Do you have a specific price range in mind?"</li>' +
                            '<li>Sell the VALUE that the price represents.</li>' +
                            '<li>Focus on the positive vs. the negative.</li>' +
                        '</ul>' +
                        'Example:  "We do have a great floor plan that is slightly above your price range, but in the ballpark.  It has some great features that I\'d love to tell you about."' +
                    '</div>';
        }
        // features
        else if (id == 8) {
            text = '<div style="padding: 1px;">' +
                        '<ul style="margin-top: 0; padding-left:2em;">' +
                            '<li>Be sure to list all of the customer\'s HOT BUTTONS in this section, which you will want to focus on when they tour and when you follow up with them.</li>' +
                            '<li>Remind the customer about the forms of payment that you accept for a deposit, the deposit amounts required to take the apartment home off of the market, and that a valid government issued photo ID is required for each person wishing to go on tour.</li>' +
                        '</ul>' +
                    '</div>';
        }
        // appointment
        else if (id == 9) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>What time are you free today to come visit the property?</li>' +
                            '<li>Do you prefer to come in at 2pm or 3:30pm?</li>' +
                            '<li>Will you be available to visit during the week or on the weekend?</li>' +
                        '</ul>' +
                    '</div>';
        }
        // email
        else if (id == 10) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>Offer to e-mail door-to-door directions and an Outlook appointment reminder.</li>' +                            
                            '<li style="font-weight:bold;">Assure the customer that they will not be receiving spam mail. It is only used as an effective communication tool.</li>' +
                        '</ul>' +
                    '</div>';
        }
        // lease term
        else if (id == 11) {
            text = '<div style="padding: 2px;">' +
                        '<ul style="padding-left:2em">' +
                            '<li>"Did you have a specific lease term in mind? Are you flexible with your lease term?"</li>' +
                            '<li>"Do you mind if I ask why you are considering a move right now?"</li>' +
                            '<li>"Are you living in an apartment home currently?" If so, assess their experience.</li>' +
                            '<li style="font-weight:bold;">Sell Greystar and our commitment to customer service.</li>' +                            
                        '</ul>' +
                    '</div>';
        }

        $('#tips').empty();
        $('#tips').append('<div></div>').append(text);

        $('#tips').show('slow');
    }
}

function hideTipBar() {
    $('#tips').hide('slow');
}
